var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgH677(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ffdf97;}.cls-2{fill:#ea8b49;}.cls-3{fill:#ffefcf;}.cls-4{fill:#ffbf57;}.cls-5{fill:#efecea;}.cls-6{fill:#cecece;}.cls-7{fill:#d37a3d;}.cls-8,.cls-9{fill:#6dd3ce;}.cls-9{mix-blend-mode:screen;}.cls-10{fill:#fff;opacity:0;}.cls-11{isolation:isolate;}.cls-12{fill:none;stroke:#ffd15c;stroke-linecap:round;stroke-linejoin:round;stroke-width:8.5px;}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    className: "cls-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_2-2"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-10",
    width: 200,
    height: 200
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M180.22,116.02l.21-.06c1.6-.39,2.59-2.01,2.21-3.62l-15.9-66.67c-.45-1.88-2.3-3.07-4.19-2.69l-.12,.02h-.02l-59.88,11.74s-3.47,1.64-1.89,12.99c1.58,11.34,11.79,75.17,11.79,75.17,0,0,.28,5.06,5.49,4.01,4.52-.9,50.23-12.8,62.21-15.93,1.61-.42,2.61-2.02,2.3-3.66l-2.19-11.31Z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 59.08,
    y: 67.1,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 81.07,
    y: 71.33,
    width: 35.53,
    height: 9.9,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 50.85,
    y: 98.46,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 72.84,
    y: 102.7,
    width: 35.53,
    height: 9.9,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 69.35,
    y: 124.51,
    width: 16.46,
    height: 16.46,
    rx: 8.23,
    ry: 8.23
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-6",
    x: 91.34,
    y: 128.75,
    width: 35.53,
    height: 9.9,
    rx: 1,
    ry: 1
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "62.11 71.41 67.94 77.33 76.98 63.18"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "54.84 101.68 60.66 107.6 69.7 93.45"
  }), /*#__PURE__*/React.createElement("polyline", {
    className: "cls-12",
    points: "72.17 127.99 77.99 133.91 87.03 119.76"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M67.4,43.08c30.11-18.04,71.57-7.92,89.77,23.18"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M58.31,49.48c.5-.42,.65-.54,1.15-.94"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M142.83,150.63c-49.26,40.42-120.85-4.55-106.29-66.21"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-12",
    d: "M150.84,142.7c-.44,.51-.88,1.02-1.34,1.53"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M111.55,151.86c-3.58,0-6.48-4.63-6.48-6.8,0-.36-.77-.36-.77,0,0,2.08-2.67,6.8-6.89,6.8-.36,0-.36,.77,0,.77,3.68,0,6.89,5.04,6.89,6.8,0,.36,.77,.36,.77,0,0-2.09,2.99-6.8,6.48-6.8,.36,0,.36-.77,0-.77Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-8",
    d: "M165.31,128.62c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M52.52,42.09c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-9",
    d: "M47.67,63.67c-1.18,0-2.14-1.53-2.14-2.25,0-.12-.26-.12-.26,0,0,.69-.88,2.25-2.28,2.25-.12,0-.12,.25,0,.25,1.22,0,2.28,1.67,2.28,2.25,0,.12,.26,.12,.26,0,0-.69,.99-2.25,2.14-2.25,.12,0,.12-.25,0-.25Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-7",
    d: "M87.85,42.08s-3.47,1.64-1.89,12.99c1.58,11.34,11.79,75.17,11.79,75.17,0,0,.28,5.06,5.49,4.01,4.52-.9,50.23-12.8,62.21-15.93,1.61-.42,2.61-2.02,2.3-3.66l-15.8-81.48c-.38-1.95-2.27-3.23-4.22-2.84l-59.88,11.74Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M90.16,41.67l57.71-11.35c1.89-.37,3.74,.82,4.19,2.69l15.9,66.67c.38,1.61-.6,3.22-2.21,3.62l-61.13,16.66c-1.12,.3-2.25-.43-2.43-1.58l-12.04-76.72Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M103.8,125.1c-.31,.86-.54,1.88-.5,2.9,.1,2.33,2.39,3.94,4.64,3.34l53.73-14.64c.69-.19,1.07-.94,.8-1.6-.65-1.56-1.34-4.47,.44-7.7,.18-.33-.12-.73-.49-.62l-55.61,15.49c-1.41,.39-2.53,1.44-3.02,2.82Z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M136.97,66.75c-6.32-5.65-13.22-18.01-13.22-18.01l-3.92,.78s-1.64,14.07-5.32,21.7l-1.18,2.43c1.18,5.93,7.12,7.12,14.48,5.73,7.33-1.54,12.36-4.91,11.18-10.84l-2.02-1.8Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M130.28,65.38c-2.85-2.54-5.96-8.12-5.96-8.12l-1.77,.35s-.74,6.34-2.4,9.78l-.53,1.1c.53,2.67,3.21,3.21,6.53,2.58,3.3-.69,5.57-2.21,5.04-4.88l-.91-.81Z"
  })))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgH677);
export default __webpack_public_path__ + "static/media/H67-7.f4864af17c43a54ea74c3752c5f0ccdf.svg";
export { ForwardRef as ReactComponent };